import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Location }                 from '@angular/common';
import { Staff } from '../Models/staff';
import { StaffService } from '../Service/staff.service';
import { Attend } from '../Models/attend';
import { AttendStaffService } from '../Service/attend-staff.service';

@Component({
  selector: 'app-attendance-staff',
  templateUrl: './attendance-staff.component.html',
  styleUrls: ['./attendance-staff.component.css']
})
export class AttendanceStaffComponent implements OnInit {

  @Input() staff: Staff;
  errmsg = '';
  sign: boolean;

  constructor(
    private staffService: StaffService,
    private AttendService: AttendStaffService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    // Get staff status and name when the page initialize
    this.route.paramMap
      .switchMap((params: ParamMap) => this.staffService.getStaffbyPin(params.get('id')))
      // .switchMap((params: ParamMap) => this.staffService.getStaff())
      .subscribe(staff => {
        this.staff = staff[0][0];
        // console.log(this.staff);
        this.sign = Boolean(this.staff.sign);

      });
  }

  // Check in event
  checkIn(){
    this.addCheckIn();
  }
  // Check out event
  checkOut(){
    this.addCheckOut();
  }
  // Add new check In
  addCheckIn() {
    // Format datetime
    let _now = new Date();
    let month = this.getMonth(_now);
    let day = this.getDay(_now);
    let hour = this.getHours(_now);
    let min = this.getMinutes(_now);
    let sec = this.getSeconds(_now);
    // Get new check in time, school id and staff id.
    let checkin = new Attend();
    checkin.stime = _now.getFullYear() + "-" + month + "-" + day
      + " " + hour + ":" + min + ":" + sec;
    checkin.sid = this.staff.id;
    checkin.school = Number(localStorage.getItem('school'));
    // Call api to add new check in attendance
    this.AttendService.addCheckIn(checkin)
    .subscribe(
      () => this.router.navigate(['/attendance']),
      err => {
        this.errmsg = 'Failure to check in, please try again';
        console.log(err);
      });
  }
  // Add new check out
  addCheckOut() {
    // Format datetime
    let _now = new Date();
    let month = this.getMonth(_now);
    let day = this.getDay(_now);
    let hour = this.getHours(_now);
    let min = this.getMinutes(_now);
    let sec = this.getSeconds(_now);
    // Get new check out time, school id and staff id.
    let checkout = new Attend();
    checkout.etime = _now.getFullYear() + "-" + month + "-" + day
      + " " + hour + ":" + min + ":" + sec;
    checkout.sid = this.staff.id;
    checkout.school = Number(localStorage.getItem('school'));
    // Call api to add new check out attendance
    this.AttendService.addCheckOut(checkout)
      .subscribe(
        () => this.router.navigate(['/attendance']),
        err => {
          this.errmsg = 'Failure to check out, please try again';
          console.log(err);
        });

  }
  // Format Seconds
  private getSeconds(date) {
    var sec = date.getSeconds();
    return sec < 10 ? '0' + sec : '' + sec; // ('' + sec) for string result
  }
  // Format Minutes
  private getMinutes(date) {
    var min = date.getMinutes();
    return min < 10 ? '0' + min : '' + min; // ('' + min) for string result
  }
  // Format Hours
  private getHours(date){
    var hour = date.getHours();
    return hour < 10 ? '0' + hour : '' + hour; // ('' + hour) for string result
  }
  // Format Days
  private getDay(date) {
    var day = date.getDate();
    return day < 10 ? '0' + day : '' + day; // ('' + day) for string result
  }
  // Format Month
  private getMonth(date) {
    var month = date.getMonth() + 1;
    return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
  }



}



// WEBPACK FOOTER //
// /home/hihoo/ibilling/attendence/public/src/app/attendance-staff/attendance-staff.component.ts